const copyViaTextRange = (input, {target = document.body} = {}) => {
  return new Promise((resolve, reject) => {

    const element = document.createElement('textarea');

    try {
      const previouslyFocusedElement = document.activeElement;

      element.value = input;

      // Prevent keyboard from showing on mobile
      element.setAttribute('readonly', '');

      element.style.contain = 'strict';
      element.style.position = 'absolute';
      element.style.left = '-9999px';
      element.style.fontSize = '12pt'; // Prevent zooming on iOS

      const selection = document.getSelection();
      let originalRange = false;
      if (selection.rangeCount > 0) {
        originalRange = selection.getRangeAt(0);
      }

      target.append(element);
      element.select();

      // Explicit selection workaround for iOS
      element.selectionStart = 0;
      element.selectionEnd = input.length;

      let isSuccess = false;

      isSuccess = document.execCommand('copy')

      element.remove();

      if (originalRange) {
        selection.removeAllRanges();
        selection.addRange(originalRange);
      }

      // Get the focus back on the previously focused element, if any
      if (previouslyFocusedElement) {
        previouslyFocusedElement.focus();
      }

      resolve(isSuccess)
    } catch (e) {
      reject(false)
    } finally {
      target.removeChild(element)
    }
  })
}


const abcCopy = function (content, { target = document.body } = {}) {
  return new Promise(async (resolve, reject) => {
    try {
      // 使用最新的api来实现，但IE不支持 https://developer.mozilla.org/en-US/docs/Web/API/Clipboard/writeText
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(content).then(() => {
          resolve()
        }).catch(async err => {
          const ret = await copyViaTextRange(content, {
            target: target
          })
          ret ? resolve() : reject('copy fail')
        })
      }
      else {
        const ret = await copyViaTextRange(content, {
          target: target
        })
        ret ? resolve() : reject('copy fail')
      }
    }
    catch (err) {
      console.error(err)
      reject(err)
    }
  })
}

module.exports = abcCopy

module.exports.default = abcCopy;
